export default (store) => ({
  path : 'issues/:id',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'IssueDetails' */
      './components/IssueDetails'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
